<button
  *ngIf="visible"
  mat-button
  color="primary"
  class="mdc-small-button"
  [disabled]="retrying"
  (click)="confirmRetry()"
>
  {{ label }}
</button>
